import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import AppointmentForm from './AppointmentForm';
import AppointmentService from '../../services/appointmentService';

const EditAppointment = () => {
  const navigate = useNavigate();
  const { appointmentId } = useParams();
  const auth = useAuth();
  const [appointment, setAppointment] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadAppointment = async () => {
      if (!appointmentId || !auth.user?.access_token) {
        setError('ID de cita no válido');
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const appointmentData = await AppointmentService.getAppointmentById(appointmentId, auth.user.access_token);
        setAppointment(appointmentData);
      } catch (error) {
        console.error('Error loading appointment:', error);
        setError('Error al cargar la cita');
      } finally {
        setIsLoading(false);
      }
    };

    loadAppointment();
  }, [appointmentId, auth.user?.access_token]);

  const handleSuccess = () => {
    // Redirect to appointments list after successful update
    navigate('/appointments');
  };

  const handleCancel = () => {
    // Go back to previous page
    navigate(-1);
  };

  const handleDelete = async () => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta cita?')) {
      try {
        await AppointmentService.deleteAppointment(appointmentId, auth.user.access_token);
        navigate('/appointments');
      } catch (error) {
        console.error('Error removing appointment:', error);
        setError('Error al eliminar la cita');
      }
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando cita...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/appointments')}>
          Volver a Citas
        </button>
      </div>
    );
  }

  if (!appointment) {
    return (
      <div className="error-container">
        <h2>Cita no encontrada</h2>
        <p>La cita solicitada no existe o ha sido eliminada.</p>
        <button onClick={() => navigate('/appointments')}>
          Volver a Citas
        </button>
      </div>
    );
  }

  return (
    <AppointmentForm
      appointment={appointment}
      isModal={false}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
      onDelete={handleDelete}
    />
  );
};

export default EditAppointment;
